
<div class="filter-content__search">
  <input class="input-classic input-classic--small" placeholder="{{ 'GLOBAL.FORM.PLACEHOLDER.SEARCH' | translate }}" type="text" [(ngModel)]="auditLocationSearchQuery" [ngModelOptions]="{standalone: true}"/>
</div>
<div class="filter-content__action">
  <button class="button--secondary button--small button--start-case filter-content__button" type="button" (click)="submitAuditLocationFilter()">{{ 'GLOBAL.ACTION.CONFIRM' | translate }}</button>
</div>